import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Icon } from "@iconify/react";
import { Divider } from "antd";

const Card = styled.div`
  border: 1px solid #eee;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  width: 100%;
  max-width: 370px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  height: 200px;
  overflow: hidden;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Badge = styled.span`
  position: absolute;
  top: 8px;
  left: ${(props) => (props.right ? "auto" : "8px")};
  right: ${(props) => (props.right ? "8px" : "auto")};
  background-color: ${(props) => props.color || "#000"};
  color: #fff;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  margin-right: 8px;
`;

const FavoriteIcon = styled(Icon)`
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 20px;
  color: #fff;
  cursor: pointer;
`;

const Content = styled.div`
  padding: 16px;
`;

const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin: 8px 0 4px;
  cursor: pointer;
`;

const Address = styled.p`
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
`;

const Features = styled.p`
  font-size: 13px;
  color: #555;
  margin-bottom: 20px;
`;

const BedBath = styled.p`
  font-size: 13px;
  color: #333;
  margin-bottom: 4px;
`;

const Price = styled.p`
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 0;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;

  button {
    flex: 1;
    height: 36px;
    font-weight: 500;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background 0.3s;
  }

  .tour-btn {
    background-color: transparent;
    border: 1px solid #888;
    color: #333;
  }

  .availability-btn {
    background-color: #111827;
    color: #fff;
  }
`;

const PropertyCard = ({
  image,
  badges,
  title,
  address,
  features,
  beds,
  bathrooms,
  price,
  onTourClick,
  onAvailabilityClick,
  listedAgo,
  onOpen,
}) => {
  return (
    <Card>
      <ImageWrapper onClick={onOpen} aria-label={`Open ${title}`}>
        <img src={image} alt={title} />
        {/* {badges?.map((badge, index) => (
          <Badge key={index} color={badge.color}>
            {badge.label}
          </Badge>
        ))} */}
        {listedAgo && (
          <Badge right color="rgba(0,0,0,0.7)">
            {listedAgo}
          </Badge>
        )}
        {/* <FavoriteIcon icon="mdi:bookmark-outline" /> */}
      </ImageWrapper>

      <Content>
        <Title onClick={onOpen} aria-label={`Open ${title}`}>
          {title}
        </Title>
        <Address>{address}</Address>
        <Features>{features?.join(" | ")}</Features>
        <BedBath>
          {beds} beds | {bathrooms} baths
        </BedBath>
        <Price>{price}</Price>
        <Divider />

        <ButtonGroup>
          <button className="tour-btn" onClick={onTourClick}>
            🏠 Tour
          </button>
          <button className="availability-btn" onClick={onAvailabilityClick}>
            Check availability
          </button>
        </ButtonGroup>
      </Content>
    </Card>
  );
};

PropertyCard.propTypes = {
  image: PropTypes.string.isRequired,
  badges: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      color: PropTypes.string,
    })
  ),
  title: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  features: PropTypes.arrayOf(PropTypes.string),
  beds: PropTypes.string,
  bathrooms: PropTypes.string,
  price: PropTypes.string,
  onTourClick: PropTypes.func,
  onAvailabilityClick: PropTypes.func,
  listedAgo: PropTypes.string,
  onOpen: PropTypes.func,
};

export default PropertyCard;
